









import { Component, Vue } from 'vue-property-decorator';
import { FitLoading, FitDialog } from '@/fit-components';
import { FitIcon } from '@/fit-ui';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { hideDialog, showDialog } from '@/fit-components/dialog/main';
import { language, reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs';
import { loginAction } from '@/util/login';

@Component({
  components: {
    FitLoading,
    FitDialog,
    FitIcon,
  },
})
export default class App extends Vue {
  lang = '';
  ready = false;
  created() {
    // 2020-12-08调整登录方式，查看main.ts
    // const isLogin =  loginAction();
    // if(!isLogin){
    this.ready = true;
    // }
    const lang = language.getLanguage();
    this.lang = lang;
    reportIndexPvUvAndTimeCost();
  }
}
